/**
 * Location Categories Field
 *
 * @author MattJS (matt@yext.com)
 */
goog.provide('yext.location.categories');
goog.provide('yext.location.categories.Categories');
goog.provide('yext.location.categories.AdditionalCategories');
goog.provide('yext.location.categories.CategoriesWarningDialog');

goog.require('yext');
goog.require('yext.categorysearcher');
goog.require('yext.location.helpers');
/** @suppress {extraRequire} */
goog.require('yext.plugins.contextualHelp');

/**
 * This is the main module for the Location Categories Field
 * @param {!Object} options Search options
 * @constructor
 */
yext.location.categories.Categories = function($ctx, options) {
  this.$ctx = $ctx;
  this.$field = $ctx.find('.js-categories-field').addBack().filter('.js-categories-field');
  this.$fieldData = $ctx.find('.js-categories-field-data');
  this.$indeterminateMessage = $ctx.find('.js-indeterminate-message');
  this.$edit = $ctx.find('.js-category-group-edit');

  this.options = options;
  this.indeterminate = !!this.$field.data('indeterminate');
  this.timestamp = '' + this.$field.data('timestamp');
  this.countryCode = this.$field.data('countryCode');
  this.countryCodes = this.getCountryCodes();
  if (!this.countryCodes.length
      && this.options
      && this.options.searchParameters
      && this.options.searchParameters.countryCodes
      && this.options.searchParameters.countryCodes.length) {
    this.countryCodes = this.options.searchParameters.countryCodes;
  }
  const _optionEntityTypeId = options && options.searchParameters && options.searchParameters.entityTypeId;
  this.entityTypeId = _optionEntityTypeId !== undefined ? _optionEntityTypeId : this.$fieldData.data('entityTypeId');
  this.excludeAdditionalChainCategories = this.options
    && this.options.searchParameters
    && this.options.searchParameters.excludeAdditionalChainCategories;

  this.additionalCategories = new yext.location.categories.AdditionalCategories(
    $ctx.find('.js-additional-categories'),
    this.countryCodes,
    this.searchOptions({
      'excludeChainCategories': this.excludeAdditionalChainCategories,
    }, true));

  this.brandCategory = this.newStandalone(
    $ctx.find('.js-brand-category-group'),
    this.searchOptions({
      'onlyChainCategories': true,
    }),
    'brand-category');

  this.primaryCategory = this.newStandalone(
    $ctx.find('.js-primary-category-group'),
    this.searchOptions({
      'excludeChainCategories': true,
    }),
    'primary-category');

  this.storeValues();
  this.setFieldData();
  this.bind();
};

// Maximum available countries to show before tooltip
yext.location.categories.Categories.MAX_COUNTRIES_DISPLAY = 4;

/**
 * @return {!Array} List of country codes
 */
yext.location.categories.Categories.prototype.getCountryCodes = function() {
  var countryCodes = [];
  if (yext.isObject(storm.countries)) {
    for (var code in storm.countries) {
      countryCodes.push(code);
    }
  }
  if (this.countryCode) {
    countryCodes.push(this.countryCode);
  }
  return countryCodes;
};

/**
 * Adds in businessId, entityTypeId and country codes to form category searcher options
 *
 * @param {!Object} searchParameters
 * @return {!Object} Category searcher options
 */
yext.location.categories.Categories.prototype.searchOptions = function(searchParameters, supportsAccurateCount) {
  searchParameters = searchParameters || {};
  searchParameters['businessId'] = yext.businessId;
  searchParameters['entityType'] = this.entityTypeId;
  if (this.countryCodes.length) {
    searchParameters['country'] = this.countryCodes;
  }

  var searchOptions = {'searchParameters': searchParameters};
  if (supportsAccurateCount) {
    searchOptions['supportsAccurateCount'] = true;
  }

  return $.extend(true, {}, this.options, searchOptions);
};

/**
 * @return {StandaloneCategory}
 */
yext.location.categories.Categories.prototype.newStandalone = function($ctx, options, type) {
  options['type'] = type;
  return new yext.location.categories.StandaloneCategory($ctx, options);
};

/**
 * Sub field bindings
 */
yext.location.categories.Categories.prototype.bind = function() {
  var self = this;

  $(this.additionalCategories).on('updated', function() {
    self.onUpdate();
  });

  $(this.brandCategory).on('updated', function() {
    self.onUpdate();
  });

  $(this.primaryCategory).on('updated', function() {
    self.onUpdate();
  });

  this.$field.find('.js-reset-categories').click(function() {
    self.indeterminate = false;
    self.onUpdate();
    self.render();
  });
};

yext.location.categories.Categories.prototype.onUpdate = function() {
  this.message('updated');
  this.setFieldData();
};

yext.location.categories.Categories.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Rebuild the field with the values given
 *
 * @param {!Object} field Details about the field to be built
 */
yext.location.categories.Categories.prototype.reconcile = function(field) {
  var brandCategory;
  var primaryCategory;
  var additionalCategories = [];

  if (field.indeterminate) {
    this.indeterminate = field.indeterminate;
  } else {
    this.indeterminate = false; // just assume this is the case
  }

  this.timestamp = field.timestamp;

  if (!this.indeterminate && field.categories.length) {
    for (var i = field.categories.length - 1; i >= 0; i--) {
      var category = field.categories[i];
      if (!brandCategory && category.isChainCategory) {
        brandCategory = category;
        field.categories.splice(i, 1);
        break;
      }
    }
    if (field.categories.length) {
      primaryCategory = field.categories[0];
      additionalCategories = field.categories.slice(1, field.categories.length);
    }
  }

  this.brandCategory.set(brandCategory);
  this.primaryCategory.set(primaryCategory);
  this.additionalCategories.reconcile({
    categories: additionalCategories,
  });
  this.render();
};

/**
 * Store the values of all category lists
 */
yext.location.categories.Categories.prototype.storeValues = function() {
  this.storedIndeterminate = this.indeterminate;
  this.additionalCategories.storeValues();
  this.brandCategory.storeValue();
  this.primaryCategory.storeValue();
};

/**
 * Reset the categories
 */
yext.location.categories.Categories.prototype.reset = function() {
  this.indeterminate = this.storedIndeterminate;
  this.additionalCategories.reset();
  this.brandCategory.reset();
  this.primaryCategory.reset();
  this.render();
};

/**
 * @return {number} The primary category id, if there is one
 */
yext.location.categories.Categories.prototype.getPrimaryCategoryId = function() {
  if (this.primaryCategory.hasCategory()) {
    return this.primaryCategory.getCategory().id;
  }
  // return undefined;
};

/**
 * @return {number} Max list size (from configuration)
 */
yext.location.categories.Categories.prototype.getMaxListSize = function() {
  return this.options.maxListSize;
};

/**
 * This adds one to the underlying additional list count to account for primary
 */
yext.location.categories.Categories.prototype.getCheckedShownCategories = function() {
  var count = this.additionalCategories.getCheckedShownCategories().length;
  if (this.primaryCategory.hasCategory()) {
    count++;
  }
  // TODO(mattjs) should this be conditional wrt isEmployee
  if (this.brandCategory.hasCategory()) {
    count++;
  }
  return count;
};

/**
 * @return {!Object} Raw field data
 */
yext.location.categories.Categories.prototype.getData = function() {
  var data = this.additionalCategories.getData();
  var primary = this.primaryCategory.getCategory();
  var brand = this.brandCategory.getCategory();
  if (primary) {
    data.categories.unshift(primary);
  }
  if (brand) {
    data.categories.unshift(brand);
  }
  data.timestamp = this.timestamp;
  return data;
};

/**
 * Sets the hidden input value to JSON representation of categories
 */
yext.location.categories.Categories.prototype.setFieldData = function() {
  this.$fieldData.val(yext.JSON.stringify(this.getData()));
};

/**
 * Render the field edit mode
 */
yext.location.categories.Categories.prototype.render = function() {
  this.$edit.toggleClass('d-none', this.indeterminate);
  this.$indeterminateMessage.toggle(this.indeterminate);
};

/**
 * Returns true if the field has no value set
 * @return {boolean}
 */
yext.location.categories.Categories.prototype.isEmpty = function() {
  return !this.additionalCategories.hasCategories()
         && !this.primaryCategory.hasCategory()
         && !this.brandCategory.hasCategory();
};

/**
 * Render the view mode for this field
 * TODO Render the new style
 *
 * @return {string} Html string for the display/view mode
 */
yext.location.categories.Categories.prototype.renderViewMode = function() {
  var $textDisplay = this.$ctx.find('.js-category-text-display');
  var $catGroups = this.$ctx.find('.js-category-group-display');

  $textDisplay.empty().toggleClass('d-none', true);
  $catGroups.toggleClass('d-none', true);

  if (this.indeterminate) {
    $textDisplay.html(yext.location.helpers.variousContentMessage()).toggleClass('d-none', false);
  } else if (this.isEmpty()) {
    $textDisplay.html(yext.location.helpers.emptyFieldMessage()).toggleClass('d-none', false);
  } else {
    var $brand = this.$ctx.find('.js-brand-category-display');
    var $primary = this.$ctx.find('.js-primary-category-display');
    var $additional = this.$ctx.find('.js-additional-categories-display');

    $brand.hide();
    $primary.hide();
    $additional.hide();

    if (this.primaryCategory.hasCategory()) {
      var fullName = this.primaryCategory.getCategory().fullName;
      $primary.find('.js-category-group-contents').html(fullName);
      $primary.show();
    }

    if (this.brandCategory.hasCategory()) {
      var fullName = this.brandCategory.getCategory().fullName;
      $brand.find('.js-category-group-contents').html(this.templateHidden(fullName));
      $brand.show();
    }

    if (this.additionalCategories.hasCategories()) {
      $additional.find('.js-category-group-contents').html(this.additionalCategories.renderViewMode());
      $additional.show();
    }

    $catGroups.toggleClass('d-none', false);
  }
};

yext.location.categories.Categories.prototype.templateHidden = function(name) {
  return '<span class="hidden-category">' + name + '</span>';
};

/** s
 * AdditionalCategories class
 *
 * Extends the CategorySearcher model
 *
 * @param {!jQuery} $ctx The container for the field
 * @param {!Array} countryCodes List of countries currently being edited
 * @param {!Object} options Configurable options for the category searcher
 * @constructor
 */
yext.location.categories.AdditionalCategories = function($ctx, countryCodes, options) {
  this.$searcher = $ctx.find('.js-category-searcher');
  this.bulkEdit = this.$searcher.data('bulkEdit');
  this.countryCodes = countryCodes;
  options['type'] = 'additional-categories';
  yext.categorysearcher.Model.call(this, $ctx, options);
};
goog.inherits(yext.location.categories.AdditionalCategories, yext.categorysearcher.Model);

/**
 * Available countries data also must be retrieved from the DOM
 */
yext.location.categories.AdditionalCategories.prototype.getCategories = function() {
  yext.location.categories.AdditionalCategories.superClass_.getCategories.call(this);

  if (this.countryCodes.length > 1) {
    var self = this;
    this.categories.forEach(function(category) {
      var $avaliableCountries = category.$element.find('.js-available-countries');
      if ($avaliableCountries.length) {
        category.model.availableCountries = $avaliableCountries.data('countries');
        self.renderAvailableCountries(category);
      }
    });
  }
};

/**
 * Render the available countries
 *
 * @param {CategoryView} category The category view being rendered
 */
yext.location.categories.AdditionalCategories.prototype.renderAvailableCountries = function(category) {
  if (!this.listsEqual(category.model.availableCountries, this.countryCodes)) {
    var $availableCountries = category.$element.find('.js-available-countries');
    var countries = [];
    category.model.availableCountries.forEach(function(countryCode) {
      countries.push(storm.countries[countryCode]);
    });
    if (category.model.availableCountries.length < yext.location.categories.Categories.MAX_COUNTRIES_DISPLAY) {
      var msg = yext.msg('(Only in {0})', yext.formatCommaList(countries));
      $availableCountries.html(msg);
    } else {
      msg = yext.msg(
        '(Only in <span>{0} out of {1} countries</span>)',
        category.model.availableCountries.length,
        this.countryCodes.length);
      $availableCountries.html(msg);
      var toolTipText = yext.msg('The category applies only to the following countries:');
      toolTipText += '<br>' + countries.join('<br>');
      $availableCountries.find('span').contextualHelp({
        basicText: toolTipText,
      });
    }
  }
};

/**
 * Returns boolean on whether or not two simple lists contain the same elements
 * in any order
 *
 * @param {!Array} l1 First list
 * @param {!Array} l2 Second list
 * @return {boolean} True if lists are equal
 */
yext.location.categories.AdditionalCategories.prototype.listsEqual = function(l1, l2) {
  if (l1.length === l2.length) {
    var l2copy = l2.slice();
    for (var i = 0; i < l1.length; i++) {
      for (var j = l2copy.length - 1; j >= 0; j--) {
        if (l2copy[j] === l1[i]) {
          l2copy.splice(j, 1);
        }
      }
    }
    return l2copy.length === 0;
  }
  return false;
};

/**
 * Intercept add category to add the country restrictions message if necessary
 *
 * @param {!Object} data Category data
 * @param {!jQuery} $input Optional input that was used for searching
 * @return {CategoryView} The view model representing the category
 */
yext.location.categories.AdditionalCategories.prototype.addCategory = function(data, $input) {
  var country = yext.location.categories.AdditionalCategories.superClass_.addCategory.call(this, data, $input);
  if (data.availableCountries && this.countryCodes.length > 1) {
    country.model.availableCountries = data.availableCountries;
    this.renderAvailableCountries(country);
  }
  return country;
};

/**
 * Rebuild the field with the values given
 *
 * @param {!Object} field Details about the field to be built
 */
yext.location.categories.AdditionalCategories.prototype.reconcile = function(field) {
  this.indeterminate = field.indeterminate || false;
  this.orderVaries = field.orderVaries || false;

  yext.location.categories.AdditionalCategories.superClass_.reconcile.call(this, field);
};

/**
 * Override parents storeValues to store a few more
 */
yext.location.categories.AdditionalCategories.prototype.storeValues = function() {
  yext.location.categories.AdditionalCategories.superClass_.storeValues.call(this);

  this.storedValues.indeterminate = this.indeterminate;
  this.storedValues.orderVaries = this.orderVaries;
};

/**
 * Make changes to the category before display
 *
 * @param {CategoryView} Category view model
 */
yext.location.categories.AdditionalCategories.prototype.renderCategory = function(categoryView) {
  var bulk = !!this.bulkEdit;
  categoryView.$element.find('.js-checked').toggleClass('d-none', !bulk);
  categoryView.$element.find('.js-delete-category').toggle(!bulk);

  if (!categoryView.model.showCategory) {
    categoryView.$element.addClass('hidden-category');
  }
};

/**
 * Make some changes to the searcher before display
 *
 * @param {!jQuery} $element The searcher
 */
yext.location.categories.AdditionalCategories.prototype.renderSearcher = function($element) {
  var bulk = !!this.bulkEdit;
  $element.find('.js-checked').toggleClass('d-none', !bulk);
  $element.find('.js-delete-category').toggle(!bulk);
};

/**
 * Render the view mode for this field
 *
 * @return {string} Html string for the display/view mode
 */
yext.location.categories.AdditionalCategories.prototype.renderViewMode = function() {
  var html = '';
  if (this.categories.length) {
    if (this.orderVaries) {
      html += '<span class="various">&lt;' +
        yext.msg('Category order varies') +
        '&gt;</span>';
    }
    html += '<ul class="categories-list">';
    for (var i = 0; i < this.categories.length; i++) {
      if (this.categories[i].model.showCategory) {
        html += '<li>' + this.categories[i].model.fullName + '</li>';
      } else {
        html += '<li class="hidden-category">' + this.categories[i].model.fullName + '</li>';
      }
    }
    html += '</ul>';
  }
  return html;
};

/**
 * Toggle the link to add another category
 */
yext.location.categories.AdditionalCategories.prototype.toggleAddCategory = function() {
  if (!this.bulkEdit) {
    yext.location.categories.AdditionalCategories.superClass_.toggleAddCategory.call(this);
  }
};

/**
 * Create a categories field object
 *
 * @param {!jQuery} $element The container for the field
 * @param {!Object} options Configurable options for the category searcher
 * @return {Categories} Categories model
 */
yext.location.categories.create = function($element, options) {
  return new yext.location.categories.Categories($element, options);
};

/**
 * @constructor
 * @param {!jQuery} $ctx The container for the standalone category
 * @param {!Object} options
 */
yext.location.categories.StandaloneCategory = function($ctx, options) {
  this.$ctx = $ctx;
  this.$message = $ctx.find('.js-standalone-select-message');
  this.$selected = $ctx.find('.js-standalone-selected');
  this.$search = $ctx.find('.js-standalone-search');

  this.searcher = yext.categorysearcher.createSingle(this.$search, options);

  this.setCategory();
  this.bind();
  this.storeValue();
};

/**
 * Pull category data off DOM
 */
yext.location.categories.StandaloneCategory.prototype.setCategory = function() {
  var category = this.$selected.data('categoryData');
  if (category) {
    this.searcher.setCategory(category);
  }
};

/**
 * Module bindings
 */
yext.location.categories.StandaloneCategory.prototype.bind = function() {
  var self = this;

  this.$ctx.find('.js-select-standalone-category').click(function() {
    self.showSearch();
  });

  this.searcher.categorySelected = function() {
    self.onUpdated();
  };

  this.searcher.categoryCleared = function() {
    self.onUpdated();
  };

  this.$ctx.find('.js-remove-category').click(function() {
    self.searcher.clearCategory();
  });
};

/**
 * Triggered when the category is selected or removed
 */
yext.location.categories.StandaloneCategory.prototype.onUpdated = function() {
  $(this).trigger('updated');
  this.render();
};

yext.location.categories.StandaloneCategory.prototype.storeValue = function() {
  if (this.searcher.category) {
    this.storedCategory = this.searcher.category.ownProperties();
  } else {
    this.storedCategory = undefined;
  }
};

yext.location.categories.StandaloneCategory.prototype.showSearch = function() {
  this.$message.toggleClass('d-none', true);
  this.$search.toggleClass('d-none', false);
  this.$search.find('input[type=text]').focus();
};

/**
 * Renders current state of the standalone category
 */
yext.location.categories.StandaloneCategory.prototype.render = function() {
  var hasCategory = !!this.searcher.category;

  if (hasCategory) {
    this.$selected.find('.js-standalone-category-name').html(this.searcher.category.fullName);
  }

  this.$search.toggleClass('d-none', true);
  this.$message.toggleClass('d-none', hasCategory);
  this.$selected.toggleClass('d-none', !hasCategory);
};

yext.location.categories.StandaloneCategory.prototype.reset = function() {
  this.set(this.storedCategory);
};

yext.location.categories.StandaloneCategory.prototype.set = function(category) {
  if (category) {
    this.searcher.setCategory(category);
  } else {
    this.searcher.clearCategory();
  }
};

yext.location.categories.StandaloneCategory.prototype.getCategory = function() {
  return this.searcher.category;
};

yext.location.categories.StandaloneCategory.prototype.hasCategory = function() {
  return this.searcher.hasCategory();
};

/**
 * @param {function()} confirm
 * @param {function()} cancel
 * @constructor
 */
yext.location.categories.CategoriesWarningDialog = function(confirm, cancel) {
  this.confirm = confirm;
  this.cancel = cancel;

  this.bind();
};

/**
 * Build and bind the dialog
 */
yext.location.categories.CategoriesWarningDialog.prototype.bind = function() {
  var self = this;
  var $dialog = $($('.js-category-change-warning-dialog-template').html());

  this.$dialog = $dialog.dialog({
    title: yext.msg('(!) Warning'),
    autoOpen: true,
    modal: true,
    draggable: false,
    resizable: false,
    minWidth: '500',
    close: function() {
      self.destroy();
    },
  });

  this.$dialog.find('.js-confirm-category-change').click(function() {
    self.$dialog.dialog('close');
    self.confirm();
    self.destroy();
  });

  this.$dialog.find('.js-cancel-category-change').click(function() {
    self.$dialog.dialog('close');
    self.cancel();
    self.destroy();
  });
};

/**
 * Prevent memory leaks
 */
yext.location.categories.CategoriesWarningDialog.prototype.destroy = function() {
  this.$dialog.dialog('destroy').remove();
};
